import React, { useState, useEffect } from 'react';
import { HashRouter as Router, Route, Routes, useNavigate } from 'react-router-dom';

// Components
import Navbar from './Components/Navbar.tsx';
import Footer from './Components/Footer.js';
import ProductList from './Pages/ProductList.jsx';
import Checkout from './Components/Checkout.tsx';
import Orders from './Pages/Orders.jsx';
import CustomProductDesigner from './Pages/CustomProductDesigner.jsx';

// Pages
import Home from './Pages/Home.jsx';
import Contact from './Pages/Contact.jsx';
import Login from './Pages/Login.tsx';
import About from './Pages/About.jsx';
import Profile from "./Pages/Profile.tsx";
import Cart from './Pages/Cart.jsx';
import PurchaseCompleted from './Pages/PurchaseCompleted.jsx';

// Context
import { CartProvider } from './context/CartContext.tsx';
import { User } from './types';

const App: React.FC = () => {
  const [user, setUser] = useState<User | null>(null);
  const navigate = useNavigateWrapper();

  const handleLogout = () => {
    setUser(null);
    localStorage.removeItem('user');
    localStorage.removeItem('token');
    navigate('/login');
    console.log('User logged out');
  };

  const closeMenu = () => console.log('Menu closed');

useEffect(() => {
  const lastClosed = localStorage.getItem("lastClosed");

  if (lastClosed) {
    const elapsed = Date.now() - parseInt(lastClosed, 10);
    // Logga ut ENDAST om det gått mer än 10 minuter
    if (elapsed > 10 * 60 * 1000) {
      handleLogout();
    }
  }

  const handleUnload = () => {
    // Sätt lastClosed först när användaren VERKLIGEN lämnar sidan
    localStorage.setItem("lastClosed", Date.now().toString());
  };

  window.addEventListener("beforeunload", handleUnload);

  return () => window.removeEventListener("beforeunload", handleUnload);
}, []);


  return (
    <CartProvider>
      <Router>
        <div className="site-container">
          <header className="site-header">
            <Navbar closeMenu={closeMenu} user={user} setUser={setUser} />
          </header>

          <main className="site-content">
           <Routes>
  <Route path="/" element={<Home />} />
  <Route path="/login" element={<Login setUser={setUser} onClose={() => console.log('Login closed')} />} />
  <Route path="/contact" element={<Contact />} />
  <Route path="/checkout" element={<Checkout />} />
  <Route path="/orders" element={<Orders />} />
  <Route path="/purchase-completed" element={<PurchaseCompleted />} />
  <Route path="/productlist" element={<ProductList />} />
  <Route path="/about" element={<About />} />
 <Route path="/profile" element={<Profile setUser={setUser} />} />
  <Route path="/design/:id" element={<CustomProductDesigner />} />
  <Route path="/cart" element={<Cart />} />
</Routes>

          </main>

          <footer className="site-footer">
            <Footer closeMenu={closeMenu} />
          </footer>
        </div>
      </Router>
    </CartProvider>
  );
};

// Custom hook för navigate utanför <Routes>
const useNavigateWrapper = () => {
  const navigateRef = React.useRef<(path: string) => void>(() => {});
  const NavigateWrapper: React.FC = () => {
    const navigate = useNavigate();
    navigateRef.current = navigate;
    return null;
  };
  return navigateRef.current;
};

export default App;
